import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getInternalWalletB2BPing, isInternalWalletApiConfigured } from '../../services/internalWalletService';

const BTN_SECONDARY =
  'btn-secondary inline-flex items-center gap-2 text-sm py-2 pl-2.5 pr-3';
const BTN_SKY =
  'btn-secondary inline-flex items-center gap-2 border-sky-200 bg-sky-50 py-2 pl-2.5 pr-3 text-sm text-sky-900 hover:bg-sky-100';

/**
 * VPN / internal API actions on the wallet home: Search Wallet and global credit issue requests.
 * Only renders buttons when ping succeeds and the corresponding feature flag is true.
 */
function WalletDashboardVpnActions() {
  const [pingStatus, setPingStatus] = useState(() => (isInternalWalletApiConfigured() ? 'loading' : 'skipped'));
  const [pingPayload, setPingPayload] = useState(null);

  const runPing = useCallback(async () => {
    if (!isInternalWalletApiConfigured()) {
      setPingStatus('skipped');
      setPingPayload(null);
      return;
    }
    setPingStatus('loading');
    setPingPayload(null);
    try {
      const data = await getInternalWalletB2BPing();
      setPingPayload(data && typeof data === 'object' ? data : {});
      setPingStatus('ready');
    } catch (e) {
      console.error(e);
      setPingStatus('unreachable');
      setPingPayload(null);
    }
  }, []);

  useEffect(() => {
    void runPing();
  }, [runPing]);

  const features = pingPayload?.features;
  const reachable = pingPayload?.accessible !== false;
  const showSearch =
    pingStatus === 'ready' && reachable && features?.list_other_user_wallets === true;
  const showCreditRequests =
    pingStatus === 'ready' && reachable && features?.wallet_credit_issue_requests === true;

  if (pingStatus === 'loading') {
    return (
      <span className="inline-flex h-9 w-[7.5rem] animate-pulse rounded-lg bg-slate-200/80" aria-hidden />
    );
  }

  if (!showSearch && !showCreditRequests) {
    return null;
  }

  return (
    <>
      {showSearch ? (
        <Link
          to="/wallets/non-user"
          className={BTN_SECONDARY}
          title="Find organisation and system wallets (VPN / internal API)"
        >
          <i className="material-icons-outlined text-base">search</i>
          Search Wallet
        </Link>
      ) : null}
      {showCreditRequests ? (
        <Link
          to="/wallets/credit-issue-requests"
          className={BTN_SKY}
          title="Review and approve or reject credit repayment requests across your wallets"
        >
          <i className="material-icons-outlined text-base">fact_check</i>
          Credit requests
        </Link>
      ) : null}
    </>
  );
}

export default WalletDashboardVpnActions;
